/* eslint-disable */
import {Filtro} from "../models/filtro/filtro";


export const DoencaSCH = (perPage)=> {
    var filtro = new Filtro()
    filtro.perPage = perPage
    filtro.fields = ['*']
  // filtro.fields = ['ordem', 'titulo', 'tp_doenca', 'texto']
    filtro.addOrder('ordem', 'asc')
  return filtro
}


export const  getDoencaSCH = (campo, valor, condicao)=>{
  var filtro = new Filtro()
  filtro.perPage = 1
  filtro.filters.addFilter(campo,valor,condicao)
  return filtro
}

